import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

const REPLAY_ROUTE_PREFIXES = ['/sign-up', '/confirm-registration', '/onboard-', '/subscription'];

export const useSessionReplayScope = (): void => {
  const { pathname } = useLocation();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    if (!REPLAY_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;

    hasStarted.current = true;
    datadogRum.startSessionReplayRecording();
  }, [pathname]);
};
